(function () {
  if (window.IXAGuideLoaded) return;
  window.IXAGuideLoaded = true;
  document.documentElement.classList.add('ixa-guide-js');

  var labels = {
    header: {
      grommet: 'Grommet',
      'rod-pocket': 'Rod Pocket',
      'back-tab': 'Back Tab',
      'french-pleat': 'French Pleat',
      'tailored-pleat': 'Tailored Pleat',
      's-fold': 'S-Fold'
    },
    panels: { single: 'Single Panel', split: 'Split Panels' },
    light: {
      blackout: '100% Blackout',
      'room-darkening': 'Room Darkening',
      'light-filtering': 'Light Filtering',
      'semi-sheer': 'Semi Sheer',
      sheer: 'Sheer'
    }
  };

  var matches = {
    blackout: {
      title: '100% Blackout Curtains',
      copy: 'Designed for maximum darkness and the highest category of light control.',
      best: 'Best for bedrooms, nurseries and media rooms.',
      lining: 'Choose the blackout construction offered on the product page. Exact performance varies by product, color and installation.',
      level: '.05'
    },
    'room-darkening': {
      title: 'Room Darkening Curtains',
      copy: 'Reduces incoming daylight and glare for a darker, calmer atmosphere.',
      best: 'Best for bedrooms, TV rooms and street-facing spaces.',
      lining: 'A privacy or room-darkening lining can add body and reduce light where the selected product offers it.',
      level: '.23'
    },
    'light-filtering': {
      title: 'Light Filtering Curtains',
      copy: 'Softens direct sun and glare while preserving a naturally bright room.',
      best: 'Best for living rooms, dining rooms and home offices.',
      lining: 'Consider light-filtering or unlined options, subject to the selected product and your privacy needs.',
      level: '.56'
    },
    'semi-sheer': {
      title: 'Semi Sheer Curtains',
      copy: 'Welcomes generous daylight with a softer view and a touch of daytime privacy.',
      best: 'Best for bright living spaces and layered window treatments.',
      lining: 'Usually best unlined or layered with a separate curtain when more nighttime privacy is needed.',
      level: '.78'
    },
    sheer: {
      title: 'Sheer Curtains',
      copy: 'Maximizes natural light and adds an airy layer of softness at the window.',
      best: 'Best for layering and rooms where daylight comes first.',
      lining: 'Choose unlined sheers for the airiest result, or layer them with another curtain for flexible privacy.',
      level: '.94'
    }
  };

  var query = new URLSearchParams(window.location.search);
  var state = {
    header: labels.header[query.get('header')] ? query.get('header') : 'french-pleat',
    panels: labels.panels[query.get('panels')] ? query.get('panels') : 'split',
    light: labels.light[query.get('light')] ? query.get('light') : 'light-filtering'
  };

  function setText(selector, value) {
    document.querySelectorAll(selector).forEach(function (node) { node.textContent = value; });
  }

  function buildUrl(rawUrl) {
    if (!rawUrl || rawUrl.charAt(0) === '#') return rawUrl;
    var target = new URL(rawUrl, window.location.origin);
    target.searchParams.set('header', state.header);
    target.searchParams.set('panels', state.panels);
    target.searchParams.set('light', state.light);
    return target.origin === window.location.origin
      ? target.pathname + target.search + target.hash
      : target.toString();
  }

  function updateAddressBar() {
    var target = new URL(window.location.href);
    target.searchParams.set('header', state.header);
    target.searchParams.set('panels', state.panels);
    target.searchParams.set('light', state.light);
    window.history.replaceState({}, '', target.pathname + target.search + target.hash);
  }

  function render() {
    document.querySelectorAll('[data-ixa-key][data-ixa-value]').forEach(function (button) {
      var selected = state[button.dataset.ixaKey] === button.dataset.ixaValue;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-checked', selected ? 'true' : 'false');
      button.setAttribute('tabindex', selected ? '0' : '-1');
    });

    Object.keys(state).forEach(function (key) {
      setText('[data-ixa-summary="' + key + '"]', labels[key][state[key]]);
    });

    var match = matches[state.light];
    setText('[data-ixa-match-title]', match.title);
    setText('[data-ixa-match-copy]', match.copy);
    setText('[data-ixa-match-best]', match.best);
    setText('[data-ixa-match-lining]', match.lining);
    document.querySelectorAll('[data-ixa-match-tone]').forEach(function (node) {
      node.style.setProperty('--ixa-light-level', match.level);
    });

    document.querySelectorAll('[data-ixa-preserve]').forEach(function (link) {
      var base = link.dataset.ixaBase || link.getAttribute('href');
      if (!base) return;
      link.dataset.ixaBase = base;
      link.setAttribute('href', buildUrl(base));
    });

    document.querySelectorAll('[data-ixa-match-link]').forEach(function (link) {
      var source = document.querySelector('[data-ixa-light-url="' + state.light + '"]');
      var raw = source ? source.dataset.ixaLightUrlValue : link.getAttribute('href');
      if (raw) link.setAttribute('href', buildUrl(raw));
    });

    document.querySelectorAll('[data-ixa-material-card]').forEach(function (card) {
      var types = (card.dataset.ixaRecommendFor || '').split(',').map(function (value) { return value.trim(); });
      card.classList.toggle('is-recommended', types.indexOf(state.light) > -1);
    });

    setText('[data-ixa-mobile-config]', labels.header[state.header] + ' · ' + labels.panels[state.panels]);
  }

  function select(button, focusButton) {
    var key = button.dataset.ixaKey;
    var value = button.dataset.ixaValue;
    if (!labels[key] || !labels[key][value]) return;
    state[key] = value;
    updateAddressBar();
    render();
    if (focusButton) button.focus();
    document.dispatchEvent(new CustomEvent('ixa:selection-change', { detail: Object.assign({}, state) }));
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ixa-key][data-ixa-value]');
    if (button) select(button, false);
  });

  document.addEventListener('keydown', function (event) {
    var button = event.target.closest('[data-ixa-key][data-ixa-value]');
    if (!button || ['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(event.key) === -1) return;
    var group = button.closest('[role="radiogroup"]');
    if (!group) return;
    var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-ixa-key][data-ixa-value]'));
    var current = buttons.indexOf(button);
    var direction = event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 1;
    var next = buttons[(current + direction + buttons.length) % buttons.length];
    event.preventDefault();
    select(next, true);
  });

  function reveal(root) {
    var nodes = (root || document).querySelectorAll('.ixa-guide__reveal:not(.is-visible)');
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nodes.forEach(function (node) { node.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: .08 });
    nodes.forEach(function (node) { observer.observe(node); });
  }

  function init(root) {
    render();
    reveal(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();